import newsletterConfig from '../../../newsletter-config.json'
import NewsletterContentButton from './NewsletterContentButton'
import NewsletterContentText from './NewsletterContentText'
import { NewsletterSectionRow, TableWrapper, TableWrapperButton } from './helpersComponents'
import { headlineMediumBold } from './helpersTypo'
import NewsletterTranslation from './NewsletterTranslation'

const NewsletterSectionCinema = ({stylesData, cinemaData, startDate, endDate, translation}) => {
    const chosenFont = stylesData.chosenFont
    const format= newsletterConfig.cinemaDateFormat
    const colorDate =  stylesData.secText ///accent_color
    const colorSubtite = stylesData.secText
    const colorButton = stylesData.buttonText
    const buttonBorder = stylesData.buttonBorder ? '1px solid ' + stylesData.buttonBorder: false
    const buttonBorderRadius = 0 != stylesData.buttonRadius ? stylesData.buttonRadius : false
    const backgroundButton = stylesData.buttonBackground
    const backgroundButtonGradient = stylesData.buttonGradient ? stylesData.buttonGradient : false

    return ([
        <NewsletterSectionRow key="1">
            <TableWrapper>
                <tr>
                    <NewsletterContentText style={{color: colorSubtite,  paddingBottom: "0px"}} align="center">
                        <h3 style={{...{color: colorSubtite, textAlign: "center"}, ...headlineMediumBold(chosenFont)}}>{cinemaData.campaignName.toUpperCase()}</h3>
                    </NewsletterContentText>
                </tr>
                <tr>
                    <NewsletterContentText style={{color: colorSubtite, paddingBottom: "34px"}} align="center">
                        <h4 style={{...{color: colorDate, textAlign: "center"}, ...headlineMediumBold(chosenFont)}}>
                            <NewsletterTranslation id="print_newsletter_preview_from" translation={translation} after=" ">Vom </NewsletterTranslation>
                            {startDate.format(format)} 
                            <NewsletterTranslation id="print_newsletter_preview_to" translation={translation} before=" " after=" "> bis </NewsletterTranslation>
                            {endDate.format(format)}
                        </h4>

                    </NewsletterContentText>
                </tr>
            </TableWrapper>
        </NewsletterSectionRow>,

        <NewsletterSectionRow key="2">
            <TableWrapperButton width={newsletterConfig.linkButtonWidth} background={backgroundButton} backgroundGradient={backgroundButtonGradient} border={buttonBorder} borderRadius={buttonBorderRadius}>
                {cinemaData.cinemaProgramUrl && 
                    <NewsletterContentButton
                        text={<NewsletterTranslation id="print_newsletter_preview_program_link" translation={translation} uppercase={true} >ZUM PROGRAMM</NewsletterTranslation>}
                        url={cinemaData.cinemaProgramUrl}
                        color={colorButton}
                        textStyles={headlineMediumBold(chosenFont)}
                    />
                }
            </TableWrapperButton>
        </NewsletterSectionRow>
    ])
}

export default NewsletterSectionCinema